import { WeekDay } from "PFTypes";

export const ISO_WEEKDAY_TO_DAY_NAME_MAP = {
  1: WeekDay.Monday,
  2: WeekDay.Tuesday,
  3: WeekDay.Wednesday,
  4: WeekDay.Thursday,
  5: WeekDay.Friday,
  6: WeekDay.Saturday,
  7: WeekDay.Sunday
};
